import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LinkActionHandlerModule } from '@avenir-client-web/link-action-handler';
import { FilterOptionValue } from '../enums/search.enums';
import { SearchResult } from '../interfaces/search.interfaces';
import { SearchBreadcrumbComponent } from '../search-breadcrumb/search-breadcrumb.component';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
  imports: [CommonModule, LinkActionHandlerModule, SearchBreadcrumbComponent],
})
export class SearchResultComponent {
  @Input() searchResult: SearchResult;

  @Input() filter: FilterOptionValue;
}
